import React, {PureComponent} from "react"
import authentication from "@irati/auth"
import {FormattedMessage} from "@irati/utils/lang"
import downloadBusinessWalletTransfersCSV from "@irati/wallet/services/downloadBusinessWalletTransfersCSV"

import ErrorText from "@irati/ui/src/ErrorText"
import id from "@irati/utils/id"
import tracking from "@irati-tracking/wallet/tenantWallet"
import {ProgressLoader, DownloadButton} from "@irati/ui/src/ProgressDownload"

import {ButtonWrapper} from "../Transactions/styled"

interface Props {}

interface State {
  loading: boolean
  error: boolean
  reportHasBeenDownloaded: boolean
  page: number
  totalPages: number
}

class TransactionHeader extends PureComponent<Props, State> {
  state = {
    loading: false,
    error: false,
    reportHasBeenDownloaded: false,
    page: 1,
    totalPages: 0
  }

  downloadPaginatedReport = async () => {
    tracking.downloadReport()
    const tenantId = authentication.userTenant().uuid
    const limit = 30
    const context = {
      totalItemsCount: 0,
      csv: ""
    }
    this.setState({loading: true, error: false})
    const getFirstPage = await downloadBusinessWalletTransfersCSV.getBusinessWalletTransferCSV({
      tenantId,
      page: 1,
      limit,
      includeHeaderRow: true
    })
    context.totalItemsCount = getFirstPage.totalItemsCount
    context.csv = getFirstPage.data
    const totalPages = Math.ceil(context.totalItemsCount / limit)

    const pages = Array.from(Array(totalPages).keys())
    for (const page of pages) {
      // eslint-disable-next-line no-await-in-loop
      const pageItem = await downloadBusinessWalletTransfersCSV.getBusinessWalletTransferCSV({
        tenantId,
        page: page + 2,
        limit,
        includeHeaderRow: false
      })
      this.setState({page: page + 1, totalPages})
      context.csv += pageItem.data
    }

    const fileName = `${authentication.userTenant().subdomain}-tenant-transaction-report.csv`
    const link = document.createElement("a")
    link.setAttribute("href", `data:text/csv;base64,${btoa(context.csv)}`)
    link.setAttribute("download", fileName)
    link.style.visibility = "hidden"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    this.setState({reportHasBeenDownloaded: true})

    setTimeout(() => {
      this.setState({reportHasBeenDownloaded: false, loading: false, error: false})
    }, 3000)
  }

  render() {
    const {loading, error, page, totalPages, reportHasBeenDownloaded} = this.state
    const idNamespace = id("TransactionHeader", this.props)
    const percent = (page * 100) / totalPages

    return loading ? (
      <ProgressLoader hasDownloaded={reportHasBeenDownloaded} percent={percent} />
    ) : (
      <ButtonWrapper>
        {error && (
          <ErrorText>
            <FormattedMessage id="wallet.tenant.downloadReport.error" />
          </ErrorText>
        )}
        <DownloadButton onClick={this.downloadPaginatedReport} text="wallet.tenant.downloadReport.button" id={idNamespace} />
      </ButtonWrapper>
    )
  }
}

export default TransactionHeader
